import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FaClock, FaInstagram, FaWhatsapp, FaEnvelope } from "react-icons/fa";
import Image1 from "../Assets/Images/greattime.jpg";
import bdvLogo from "../Assets/Images/CARDANO.png";
import banescoLogo from "../Assets/Images/ETH.png";
import mercantilLogo from "../Assets/Images/DOGE.png";
import provincialLogo from "../Assets/Images/BTC.png";
import bancaribeLogo from "../Assets/Images/USDC.png";
import tesoroLogo from "../Assets/Images/SOLANA.png";
import bicentenarioLogo from "../Assets/Images/THETER.png";
import faqImage from "../Assets/Images/faq.jpg";
import logo from "../Assets/Images/remesalogo.png";
import slogan from "../Assets/Images/sloganremesa.png";
import person from "../Assets/Images/person1.jpg";
import friends from "../Assets/Images/Friends.jpg";
import man  from "../Assets/Images/woman.webp";
import { NavBar } from "../Components/NavBar";
import { Footer } from "../Components/Footer";
import { Spinner } from "../Components/Spinner";
import { CookiesC } from "../Components/CookiesC";
import happyperson from "../Assets/Images/happyperson.jpg";
import { ShieldCheck, Zap } from "lucide-react";
import GoogleReviewsWidget from "../Components/GoogleReviewsWidget";

// Import de Hooks
import { useCurrencyPrice } from "../Hooks/useCurrencyPrice";

function HomeUSA() {
  const { data } = useCurrencyPrice();
  const [isLoading, setIsLoading] = useState(true);
  const [sendAmount, setSendAmount] = useState(100);
  const [receiveAmount, setReceiveAmount] = useState(0);
  const [sendCountry, setSendCountry] = useState("USD");
  const [receiveCountry, setReceiveCountry] = useState("VEF");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState({
    flag: "🇪🇸",
    name: "España",
  });
  const countriesList = [
    { flag: "🇪🇸", name: "España" },
    { flag: "🇫🇷", name: "Francia" },
    { flag: "🇩🇪", name: "Alemania" },
    { flag: "🇮🇹", name: "Italia" },
    { flag: "🇵🇹", name: "Portugal" },
    { flag: "🇳🇱", name: "Países Bajos" },
    { flag: "🇧🇪", name: "Bélgica" },
    { flag: "🇱🇺", name: "Luxemburgo" },
    { flag: "🇨🇭", name: "Suiza" },
    { flag: "🇦🇹", name: "Austria" },
    { flag: "🇸🇪", name: "Suecia" },
    { flag: "🇳🇴", name: "Noruega" },
    { flag: "🇩🇰", name: "Dinamarca" },
    { flag: "🇫🇮", name: "Finlandia" },
    { flag: "🇮🇪", name: "Irlanda" },
    { flag: "🇬🇧", name: "Reino Unido" },
    { flag: "🇵🇱", name: "Polonia" },
    { flag: "🇨🇿", name: "República Checa" },
    { flag: "🇭🇺", name: "Hungría" },
    { flag: "🇸🇰", name: "Eslovaquia" },
    { flag: "🇸🇮", name: "Eslovenia" },
    { flag: "🇭🇷", name: "Croacia" },
    { flag: "🇷🇸", name: "Serbia" },
    { flag: "🇧🇬", name: "Bulgaria" },
    { flag: "🇷🇴", name: "Rumanía" },
    { flag: "🇱🇹", name: "Lituania" },
    { flag: "🇱🇻", name: "Letonia" },
    { flag: "🇪🇪", name: "Estonia" },
    { flag: "🇮🇸", name: "Islandia" },
    { flag: "🇲🇹", name: "Malta" },
    { flag: "🇨🇾", name: "Chipre" },
    { flag: "🇬🇷", name: "Grecia" },
    { flag: "🇨🇴", name: "Colombia" },
    { flag: "🇵🇪", name: "Perú" },
    { flag: "🇦🇷", name: "Argentina" },
    { flag: "🇨🇱", name: "Chile" },
    { flag: "🇧🇷", name: "Brasil" },
  ];


  const phrases = React.useMemo(
    () => [
      "Sin comisiones",
      "Transferencias en minutos",
      "Desde Europa a Venezuela",
      "Fácil, rápido y seguro",
    ],
    []
  );

  const benefits = [
    {
      title: "Sin comisiones",
      description: "No cobramos comisiones. Lo que envías, llega completo.",
    },
    {
      title: "Transferencias rápidas",
      description: "Tu familia recibe el dinero en menos de 10 minutos.",
    },
    {
      title: "Todos los bancos",
      description: "Transferimos a cualquier banco de Venezuela, incluyendo PagoMóvil.",
    },
    {
      title: "Monto mínimo: 20€",
      description: "Envía desde solo 20 euros. Simple y rápido.",
    },
  ];


  const [activeIndex, setActiveIndex] = useState(null);
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [currentText, setCurrentText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);



  useEffect(() => {
    const currentPhrase = phrases[currentPhraseIndex];
    const delay = isDeleting ? 50 : 150;

    const timeout = setTimeout(() => {
      if (isDeleting) {
        setCurrentText((prev) => prev.slice(0, -1));
      } else {
        setCurrentText((prev) => currentPhrase.slice(0, prev.length + 1));
      }

      if (!isDeleting && currentText === currentPhrase) {
        setTimeout(() => setIsDeleting(true), 1500);
      } else if (isDeleting && currentText === "") {
        setIsDeleting(false);
        setCurrentPhraseIndex((prev) => (prev + 1) % phrases.length);
      }
    }, delay);

    setTimeout(() => setIsLoading(false), 1300);

    return () => clearTimeout(timeout);
  }, [currentText, isDeleting, currentPhraseIndex, phrases]);



  useEffect(() => {
    const calculateRemittance = () => {
      if (data.length === 0) {
        console.log("Exchange rate is empty or not loaded.");
        return;
      }

      let selectedRate;

      if (sendCountry === "EUR") {
        if (receiveCountry === "VEF") {
          selectedRate = data.cur_EurToBs;
        } else if (receiveCountry === "ARS") {
          selectedRate = data.cur_EurToArg_Pes;
        } else if (receiveCountry === "COP") {
          selectedRate = data.cur_EurToCol_Pes;
        } else if (receiveCountry === "MEX") {
          selectedRate = data.cur_EurToPes_Mex;
        } else if (receiveCountry === "PEN") {
          selectedRate = data.cur_EurToSol_Pe;
        } else if (receiveCountry === "CLP") {
          selectedRate = data.cur_EurToPes_Ch;
        } else if (receiveCountry === "BRL") {
          selectedRate = data.cur_EurToBra_Rea;
        } else if (receiveCountry === "USD") {
          selectedRate = data.cur_EurToUsd;
        } else if (receiveCountry === "PAB") {
          selectedRate = data.cur_EurToUsd_Pa;
        } else if (receiveCountry === "USD_ECU") {
          selectedRate = data.cur_EurToUsd_Ecu;
        } else if (receiveCountry === "DOP") {
          selectedRate = data.cur_EurToDop;
        }
      } else if (sendCountry === "USD") {
        if (receiveCountry === "VEF") {
          selectedRate = data.cur_UsdToBs;
        } else if (receiveCountry === "ARS") {
          selectedRate = data.cur_UsdToArg_Pes;
        } else if (receiveCountry === "COP") {
          selectedRate = data.cur_UsdToCol_Pes;
        } else if (receiveCountry === "MEX") {
          selectedRate = data.cur_UsdToPes_Mex;
        } else if (receiveCountry === "PEN") {
          selectedRate = data.cur_UsdToSol_Pe;
        } else if (receiveCountry === "CLP") {
          selectedRate = data.cur_UsdToPes_Ch;
        } else if (receiveCountry === "BRL") {
          selectedRate = data.cur_UsdToBra_Rea;
        } else if (receiveCountry === "USD") {
          selectedRate = data.cur_UsdToUsd;
        } else if (receiveCountry === "PAB") {
          selectedRate = data.cur_UsdToUsd_Pa;
        } else if (receiveCountry === "USD_ECU") {
          selectedRate = data.cur_UsdToUsd_Ecu;
        } else if (receiveCountry === "DOP") {
          selectedRate = data.cur_UsdToDop;
        }
      } else if (sendCountry === "GBP") {
        if (receiveCountry === "VEF") {
          selectedRate = data.cur_GbpToBs;
        } else if (receiveCountry === "ARS") {
          selectedRate = data.cur_GbpToArg_Pes;
        } else if (receiveCountry === "COP") {
          selectedRate = data.cur_GbpToCol_Pes;
        } else if (receiveCountry === "MEX") {
          selectedRate = data.cur_GbpToPes_Mex;
        } else if (receiveCountry === "PEN") {
          selectedRate = data.cur_GbpToSol_Pe;
        } else if (receiveCountry === "CLP") {
          selectedRate = data.cur_GbpToPes_Ch;
        } else if (receiveCountry === "BRL") {
          selectedRate = data.cur_GbpToBra_Rea;
        } else if (receiveCountry === "USD") {
          selectedRate = data.cur_GbpToUsd;
        } else if (receiveCountry === "PAB") {
          selectedRate = data.cur_GbpToUsd_Pa;
        } else if (receiveCountry === "USD_ECU") {
          selectedRate = data.cur_GbpToUsd_Ecu;
        } else if (receiveCountry === "DOP") {
          selectedRate = data.cur_GbpToDop;
        }
      }

      setReceiveAmount(sendAmount * selectedRate);
    };

    calculateRemittance();
  }, [sendCountry, receiveCountry, sendAmount, data]);

  return (
    <div className="home-page">
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <NavBar />
          <CookiesC />
<section className="hero">
            <div className="hero-overlay" />
            <div className="hero-content">
              {/* Texto */}
              <motion.div
                className="hero-text"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: "easeOut" }}
              >
                <div className="hero-text"   >
                  <h1>
                    Envía dinero con <span>respaldo</span> y <span>transparencia</span>
                  </h1>
                  <div className="typing-effect">
                    <p className="subtext typing-effect">
                      <span className="typed-text">{currentText}</span>
                      <span className="cursor" />
                    </p>
                  </div>

                  <p>
                    Transfiere en minutos desde Europa a Venezuela. Sin comisiones ocultas, tasa competitiva y soporte humano cuando lo necesites.
                  </p>
                  <Link to="/Login">
                    <button className="cta-button">Haz tu envío ahora</button>
                  </Link>
                  <div className="envios-badges">
  <motion.div
    className="envio-badge"
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.97 }}
  >
    <Zap className="icon" />
    <span>Rápido y claro: ves el costo total antes de confirmar</span>
  </motion.div>

  </div>
                  <div className="envios-badges">

  <motion.div
    className="envio-badge"
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.97 }}
  >
    <ShieldCheck className="icon" />
    <span>Seguro: cifrado y verificación protegen tus envíos</span>
  </motion.div>
</div>

                </div>
              </motion.div>


              <div className="hero-image-float">
                <motion.div
                  className="hero-person"
                  initial={{ opacity: 0, y: 100 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 1, ease: "easeOut", delay: 0.5 }}
                >
                  <img src={man} alt="Persona usando la app" />
                </motion.div>
              </div>


              <div className="home__calculator" data-aos="fade-left">
                <motion.div
                  className="home__calculator"
                  initial={{ opacity: 0, x: 100 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, ease: "easeOut", delay: 0.8 }}
                >
                  <div className="calculator-card">
                    {/* Encabezado */}
                    <div className="calculator-header-v2">
                      <img src={logo} alt="Logo Remesa España" className="calc-logo-v2" />
                      <div className="header-text-v2">
                        <img src={slogan} alt="Slogan Remesa España" className="calc-slogan-v2" />
                      </div>
                    </div>

                    {/* Sección "Envías desde" visual */}
                    <div className="calculator-section-v2">
                      <label className="label-v2">Envías desde</label>
                      <div
                        className="custom-select-v2"
                        onClick={() => setDropdownOpen(!dropdownOpen)}
                      >
                        <span className="selected-flag-v2">{selectedCountry.flag}</span>
                        <span className="selected-country-v2">{selectedCountry.name}</span>
                        <span className="arrow-icon-v2">{dropdownOpen ? "▲" : "▼"}</span>

                        {/* Dropdown visual */}
                        {dropdownOpen && (
                          <ul className="dropdown-visual-v2">
                            {countriesList.map((country, idx) => (
                              <li
                                key={idx}
                                onClick={() => {
                                  setSelectedCountry(country);
                                  setDropdownOpen(false);
                                }}
                              >
                                <span className="flag-v2">{country.flag}</span>
                                <span className="country-name-v2">{country.name}</span>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>

                    {/* Inputs Envías/Reciben */}
                    <div className="transaction-inputs-v2">
                      {/* Envías */}
                      <div className="input-group-v2">
                        <label className="label-v2">Envías</label>
                        <div className="currency-input-wrapper-v2">
                          <input
                            type="number"
                            value={sendAmount}
                            onChange={(e) => setSendAmount(e.target.value)}
                            className="calc-input-v2"
                          />
                          <select
                            value={sendCountry}
                            onChange={(e) => setSendCountry(e.target.value)}
                            className="currency-select-v2"
                          >
                            <option value="EUR">🇪🇺 EUR</option>
                            <option value="USD">🇺🇸 USD</option>
                            <option value="GBP">🇬🇧 GBP</option>
                          </select>
                        </div>
                      </div>

                      {/* Reciben */}
                      <div className="input-group-v2">
                        <label className="label-v2">Reciben</label>
                        <div className="currency-input-wrapper-v2">
                          <input
                            type="text"
                            value={receiveAmount.toFixed(2)}
                            readOnly
                            className="calc-input-v2 readonly"
                          />
                          <select
                            value={receiveCountry}
                            onChange={(e) => setReceiveCountry(e.target.value)}
                            className="currency-select-v2"
                          >
                            <option value="VEF">🇻🇪 VEF</option>
                            <option value="COP">🇨🇴 COP</option>
                            <option value="ARS">🇦🇷 ARS</option>
                            <option value="PAB">🇵🇦 PAB</option>
                            <option value="BRL">🇧🇷 BRL</option>
                            <option value="PEN">🇵🇪 PEN</option>
                            <option value="CLP">🇨🇱 CLP</option>
                            <option value="USD_ECU">🇪🇨 USD</option>
                            <option value="DOP">🇩🇴 DOP</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    {/* Info Box */}
                    <div className="calculator-info-v2">
                      <p>
                        <span className="info-label-v2">Tasa de cambio</span>
                        <span className="info-value-v2">
                          {(() => {
                            // Seleccionamos la tasa según sendCountry y receiveCountry
                            let rate = 0;

                            if (sendCountry === "EUR") {
                              if (receiveCountry === "VEF") rate = data.cur_EurToBs;
                              else if (receiveCountry === "ARS") rate = data.cur_EurToArg_Pes;
                              else if (receiveCountry === "COP") rate = data.cur_EurToCol_Pes;
                              else if (receiveCountry === "PEN") rate = data.cur_EurToSol_Pe;
                              else if (receiveCountry === "CLP") rate = data.cur_EurToPes_Ch;
                              else if (receiveCountry === "BRL") rate = data.cur_EurToBra_Rea;
                              else if (receiveCountry === "USD") rate = data.cur_EurToUsd;
                              else if (receiveCountry === "PAB") rate = data.cur_EurToUsd_Pa;
                              else if (receiveCountry === "USD_ECU") rate = data.cur_EurToUsd_Ecu;
                              else if (receiveCountry === "DOP") rate = data.cur_EurToDop;
                            } else if (sendCountry === "USD") {
                              if (receiveCountry === "VEF") rate = data.cur_UsdToBs;
                              else if (receiveCountry === "ARS") rate = data.cur_UsdToArg_Pes;
                              else if (receiveCountry === "COP") rate = data.cur_UsdToCol_Pes;
                              else if (receiveCountry === "PEN") rate = data.cur_UsdToSol_Pe;
                              else if (receiveCountry === "CLP") rate = data.cur_UsdToPes_Ch;
                              else if (receiveCountry === "BRL") rate = data.cur_UsdToBra_Rea;
                              else if (receiveCountry === "USD") rate = data.cur_UsdToUsd;
                              else if (receiveCountry === "PAB") rate = data.cur_UsdToUsd_Pa;
                              else if (receiveCountry === "USD_ECU") rate = data.cur_UsdToUsd_Ecu;
                              else if (receiveCountry === "DOP") rate = data.cur_UsdToDop;
                            } else if (sendCountry === "GBP") {
                              if (receiveCountry === "VEF") rate = data.cur_GbpToBs;
                              else if (receiveCountry === "ARS") rate = data.cur_GbpToArg_Pes;
                              else if (receiveCountry === "COP") rate = data.cur_GbpToCol_Pes;
                              else if (receiveCountry === "PEN") rate = data.cur_GbpToSol_Pe;
                              else if (receiveCountry === "CLP") rate = data.cur_GbpToPes_Ch;
                              else if (receiveCountry === "BRL") rate = data.cur_GbpToBra_Rea;
                              else if (receiveCountry === "USD") rate = data.cur_GbpToUsd;
                              else if (receiveCountry === "PAB") rate = data.cur_GbpToUsd_Pa;
                              else if (receiveCountry === "USD_ECU") rate = data.cur_GbpToUsd_Ecu;
                              else if (receiveCountry === "DOP") rate = data.cur_GbpToDop;
                            }

                            return rate ? `1 ${sendCountry} = ${rate} ${receiveCountry}` : "...";
                          })()}
                        </span>
                      </p>

                      <p>
                        <span className="info-label-v2">Cargo</span>
                        <span className="info-value-v2">0</span>
                      </p>

                      <p>
                        <span className="info-label-v2">Entrega</span>
                        <span className="info-value-v2">{receiveAmount}</span>
                      </p>
                    </div>


                    {/* Botón */}
                    <Link to="/Login">
                      <button className="start-button-v2">Comenzar →</button>
                    </Link>
                  </div>
                </motion.div>
              </div>




            </div>

            {/* Shapes flotantes */}
            <div className="hero-shape shape1" />
            <div className="hero-shape shape2" />
            <div className="hero-shape shape3" />

            {/* SVG decorativo */}
            <svg className="hero-wave" viewBox="0 0 1440 320">
              <path
                className="wave-path"
                fill="#2a9d8f"
                fillOpacity="0.2"
                d="M0,160L60,149.3C120,139,240,117,360,128C480,139,600,181,720,186.7C840,192,960,160,1080,138.7C1200,117,1320,107,1380,101.3L1440,96L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
              ></path>
            </svg>
          </section>





          <section className="steps-timeline-vertical">
            <h2 className="steps-title">Envía tu dinero en 4 simples pasos</h2>

            <div className="timeline-vertical-container">
              <div className="timeline-steps">
                {[
                  {
                    number: 1,
                    title: "Regístrate",
                    desc: "Completa tu formulario con tus datos personales, correo, teléfono y verificación de identidad. Todo en minutos y con total seguridad.",
                  },
                  {
                    number: 2,
                    title: "Transfiere",
                    desc: "Envía dinero desde Europa o cualquier país con total seguridad y sin complicaciones. Selecciona la moneda y el monto.",
                  },
                  {
                    number: 3,
                    title: "Elige el método de entrega",
                    desc: "Decide cómo tu familiar recibirá el dinero: cuenta bancaria, pago móvil o efectivo en ventanilla. Flexibilidad total.",
                  },
                  {
                    number: 4,
                    title: "Envía y listo",
                    desc: "Tu familiar recibe el dinero en minutos, sin comisiones y con confirmación inmediata. ¡Así de rápido y sencillo!",
                  },
                ].map((step, i) => (
                  <div className="timeline-step-vertical" key={i}>
                    <div className="timeline-circle">{step.number}</div>
                    <div className="timeline-text">
                      <h3>{step.title}</h3>
                      <p>{step.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Espacio para imagen de persona */}
              <div className="timeline-image-placeholder">
                <img src={person} alt="Persona enviando dinero"
                  className="timeline-person-image" />
              </div>
            </div>
          </section>

          <section className="benefits-section">
            <h2 className="section-title">Beneficios de usar RemesaEspana</h2>
            <div className="benefits-container">

              {/* Imagen pequeña a la izquierda */}
              <div className="benefits-image">
                <img src={Image1} alt="Representación Premium" />
              </div>

              {/* Beneficios a la derecha */}
              <div className="benefits-content">
                {benefits.map((item, index) => (
                  <motion.div
                    className="benefit-item"
                    key={index}
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, delay: index * 0.2 }}
                    viewport={{ once: true }}
                  >
                    <div className="benefit-icon">{index + 1}</div>
                    <div className="benefit-text">
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </section>









          <section className="rewards-section">
            <div className="rewards-container">


              {/* Carta principal con contenido */}
              <motion.div
                className="rewards-card rewards-card-main"
                initial={{ x: 100, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.3 }}
              >
                <div className="rewards-content">
                  {/* Imagen a la izquierda */}
                  <div className="rewards-image">
                    <img src={happyperson} alt="Acumula puntos con RemesaEspana" />
                  </div>

                  {/* Texto y botón a la derecha */}
                  <div className="rewards-text">
                    <h2>¡Acumula puntos con tu remesa!</h2>
                    <p>
                      Por cada envío acumulas puntos y al invitar a tus amigos ganas aún más. Con RemesaEspana,
                      enviar siempre te da beneficios exclusivos.
                    </p>
                    <Link to="/Login">
                    <button className="btn-rewards"> 
                      ¡Quiero acumular puntos! <span className="btn-arrow">→</span>
                    </button></Link>
                  </div>
                </div>
              </motion.div>
            </div>
          </section>

          <section className="invite-section">
            <div className="invite-container">
              <div className="invite-text" data-aos="fade-right" data-aos-duration="800">
                <div className="invite-icon">🎁</div>
                <h2 className="invite-title">Invita y gana 5€</h2>
                <p className="invite-description">
                  Comparte tu código de referido y cuando tu amigo haga su primer envío, ambos recibirán 5€ en su próxima remesa.
                </p> 
                <Link to="/Login">
                <button className="btn-invite" > 
                  Compartir código <span className="btn-arrow">➡️</span>               

                </button>
                </Link>
               
              </div>
              <div className="invite-image" data-aos="fade-left" data-aos-duration="800">
                <img src={friends} alt="Invita a tus amigos y gana" />
              </div>
            </div>
          </section>






          <section className="contact-section">
            <div className="contact-card">
              {[
                {
                  icon: <FaClock />,
                  title: "Horario",
                  content: (
                    <>
                      Lunes a Sábado <br /> 12:00 - 24:00 (hora España)
                    </>
                  ),
                },
                {
                  icon: <FaInstagram />,
                  title: "Instagram",
                  content: (
                    <a
                      href="https://www.instagram.com/remesaespana/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      @remesaespana
                    </a>
                  ),
                },
                {
                  icon: <FaWhatsapp />,
                  title: "WhatsApp",
                  content: (
                    <a
                      href="https://wa.me/+34722850962"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      +34 722 850962
                    </a>
                  ),
                },
                {
                  icon: <FaEnvelope />,
                  title: "Email",
                  content: (
                    <a href="mailto:info@remesaespana.com">info@remesaespana.com</a>
                  ),
                },
              ].map((box, i) => (
                <motion.div
                  className="info-box"
                  key={i}
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: i * 0.15, duration: 0.5 }}
                  whileHover={{ y: -5, boxShadow: "0 15px 30px rgba(42,157,143,0.2)" }}
                >
                  <div className="icon">{box.icon}</div>
                  <h4>{box.title}</h4>
                  <p>{box.content}</p>
                </motion.div>
              ))}
            </div>
          </section>

          <section className="banks-carousel-section">
            <div className="banks-carousel-container">
              <h2 className="banks-carousel-title">
                Trabajamos con todas las criptomonedas
              </h2>
              <div className="banks-carousel-track">
                {[
                  { name: "Cardano", src: bdvLogo },
                  { name: "Ethereum", src: banescoLogo },
                  { name: "DogeCoin", src: mercantilLogo },
                  { name: "Bitcoin", src: provincialLogo },
                  { name: "USDC", src: bancaribeLogo },
                  { name: "Solana", src: tesoroLogo },
                  { name: "Tether", src: bicentenarioLogo },
                ]
                  .concat([
                    // Repetimos para loop infinito
                    { name: "Cardano", src: bdvLogo },
                    { name: "Ethereum", src: banescoLogo },
                    { name: "DogeCoin", src: mercantilLogo },
                    { name: "Bitcoin", src: provincialLogo },
                    { name: "USDC", src: bancaribeLogo },
                    { name: "Solana", src: tesoroLogo },
                    { name: "Tether", src: bicentenarioLogo },
                  ])
                  .map((crypto, i) => (
                    <div className="carousel-logo" key={i}>
                      <img src={crypto.src} alt={crypto.name} />
                    </div>
                  ))}
              </div>
            </div>
          </section>


          <section className="faq-section">
            <div className="faq-container">
              <div className="faq-content">
                <div className="faq-image">
                  <img src={faqImage} alt="Preguntas frecuentes" />
                </div>
                <div className="faq-text">
                  <h2 className="faq-title">Preguntas Frecuentes</h2>
                  <div className="faq-list">
                    {[
                      {
                        question: "¿Cuánto tarda una transferencia?",
                        answer:
                          "El tiempo promedio es menor a 10 minutos, aunque puede variar según el banco receptor.",
                      },
                      {
                        question: "¿Qué documentos necesito para registrarme?",
                        answer:
                          "Necesitas una identificación vigente (DNI, pasaporte o NIE) y un correo electrónico.",
                      },
                      {
                        question: "¿Cobran alguna comisión?",
                        answer:
                          "No cobramos comisión por envío. El monto que transfieres es el que recibe tu familiar.",
                      },
                      {
                        question: "¿Es seguro enviar dinero?",
                        answer:
                          "Sí, utilizamos conexiones cifradas y procesos de validación para garantizar la seguridad.",
                      },
                    ].map((item, i) => (
                      <div
                        key={i}
                        className={`faq-item ${activeIndex === i ? "open" : ""
                          }`}
                      >
                        <button
                          className="faq-question"
                          onClick={() =>
                            setActiveIndex(activeIndex === i ? null : i)
                          }
                          aria-expanded={activeIndex === i}
                        >
                          <span>{item.question}</span>
                          <svg
                            className="arrow"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.08 1.04l-4.25 4.25a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </button>
                        <div
                          className="faq-answer"
                          style={{
                            maxHeight: activeIndex === i ? "200px" : "0",
                            opacity: activeIndex === i ? 1 : 0,
                          }}
                        >
                          <p>{item.answer}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>

         <GoogleReviewsWidget />

          <Footer />
        </>
      )}
    </div>
  );
}

export { HomeUSA };
